import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-theme-toggle-button',
  imports: [CommonModule],
  templateUrl: './theme-toggle-button.component.html',
})
export class ThemeToggleButtonComponent {
  readonly theme = inject(ThemeService);
  readonly theme$ = this.theme.theme$;

  toggleTheme() {
    this.theme.toggleTheme();
  }
}
